import {
  CaretDownFilled,
  CaretDownOutlined,
  CaretUpOutlined, ExclamationCircleFilled,
  MedicineBoxOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  message,
  notification,
  Popconfirm,
  Radio,
  Row,
  Select,
  Space,
  Table, TableColumnType,Modal
} from 'antd'
import _, { sum } from 'lodash'
import moment from 'moment'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './DeliveryList.module.css'
import {
  selectInsuranceArray,
  selectUserName,
  selectTenantAddress,
  selectTenantAreaCd,
  selectTenantName,
  selectUserId,
  selectTenantCategory,
  selectDispensingAutoPrintTemplateData,
  selectTenantCityCode,
  selectShortName,
  selectTenantCountyCode,
  selectTenantId,
} from '../../app/applicationSlice'
import { RootDispatch } from '../../app/store'
import {
  DateRangeFieldName, DateRangeNoYearButLastMonth,
  DateRangeType,
  DateSelect,
  getDateRange,
} from '../../compnents/form/DateSelect'
import { EditableList } from '../../compnents/list/EditableList'
import { selectInsuranceItem, setInsurance } from '../../layouts/insuranceSlice'
import { traceRoute } from '../../layouts/layoutSlice'
import {
  DateTimeFormat,
  DateTimeFormatSimpleOnly,
  DateTimeFormatSimpleOnlyOne,
} from '../../models/datetime'
import { DeliveryState } from '../../models/delivery'
import JXImg from '../../layouts/img/JXImg.png'
import { Dimen } from '../../models/dimen'
import { DefaultPageSize } from '../../models/pagination'
import { getGenderName } from '../../models/user'
import { DeliveryListParams } from '../../services/delivery'
import { ThemeContext } from '../../theme/ThemeContext'
import { strParse, medicalSendHttp, readCardEHttp } from '../../utils/MedicalUtils'
import { uploadOptions } from '../InventoryChecking/query'
import {
  drugUploadAAsync,
  drugUploadAsync, returnDrugUploadAAsync,
  returnDrugUploadAsync,
  selectPutstorageData,
} from '../putstorage/putstorageSlice'
import { RecipeListModal } from '../recipe/modal/RecipeListModal'
import {
  DeliveryItem,
  directDeliver,
  getDeliveryList,
  selectDeliveryListPage,
  getDeliveryListExoprt, getCheckTraceCodeAlarm,
} from './deliverySlice'
import { serverType } from '../../services/commodity'
import { getAge } from '../../utils/StringUtils'
import { DataType } from '../putstorage/putstorage'
import { TableRowSelection } from 'antd/lib/table/interface'
import { PrintTemplate, PrintTemplateCategory } from '../../models/print'
import { PrintTemplateModal } from '../print/PrintTemplateModal'
import {getPaymentResults,cancelSaleUpload,getAllPaymentResult} from "../payment/result/paymentResultSlice";
import {removeSale3507AAsync,} from '../putstorage/putstorageSlice'
import {TraceCodeInputModal} from "../payment/list/TraceCodeInputModal";
import { Checks } from '../../models/setting'
import { selectSettings } from '../user/setting/settingSlice'
import { getWebPrintDataByPaymentId } from '../recipe/recipeListSlice'
import { invoicenumberconfigAsync } from '../tenant/tenantSlice'
import { fromMaterialJson } from '../../models/material'
import { PrintKQBody, PrintTYBody, PrintZLZXDBody, PrintZXDBody, PrintZYBody } from '../../models/PrintTemplateModalPrint'
import { getPrintRecipeAsyncByPaymentId, getPrintTemplateSettingDetail, printTemplate, selectTemplateDefaultPrinters, selectTemplateOffsets } from '../print/printSlice'
import { getSexData } from '../../models/ToothHome'
import { subPrintInvoiceFeeBillForWeb } from '../../models/invoiceFeeBillForWeb'
import { subPrintPrescriptionContent, subZYPrintPrescriptionContent } from '../../models/recipeEditorPrint'

interface DeliveryListProps {
  deliveryState: DeliveryState
  tockSalesUploadCategoryType?: number
  station?:any
  shipmentsState?: any
}

export const DeliveryList = ({
  deliveryState,
  tockSalesUploadCategoryType,
  station,
  shipmentsState,
}: DeliveryListProps): ReactElement => {
  const inputRef = useRef<any>(null)

  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()
  const [loading, setLoading] = useState<'return' | 'ship' | ''>('')

  const page = useSelector(selectDeliveryListPage(deliveryState))

  const settings: any = useSelector(selectSettings)

  const offsets = useSelector(selectTemplateOffsets)

  const shortName = useSelector(selectShortName)

  const yjfyhzddy = settings?.[Checks?.YJFYHZDDY]

  const cityCode = useSelector(selectTenantCityCode)

  const countyCode = useSelector(selectTenantCountyCode)

  const tenantId = useSelector(selectTenantId)
  
  const defaultPrinters = useSelector(selectTemplateDefaultPrinters)
  
  const dispensingAutoPrintTemplateData: any = useSelector(selectDispensingAutoPrintTemplateData) //一键发药后自动打印

  const [head, tail] = getDateRange(DateRangeType.Today)

  const [exportLoading, setExportLoading] = useState(false)

  const [queries, setQueries] = useState<DeliveryListParams>({
    current: 0,
    size: DefaultPageSize,
    shipmentsState: deliveryState,
    timeHead: head,
    timeTail: tail,
  })

  const [errors, setErrors] = useState<{ name: string; message: string }[]>([])

  const [invoiceNo, setInvoiceNo] = useState('')
  
  const [chargeNumber, setChargeNumber] = useState<any>({})

  const [paymentInfo, setPaymentInfo] = useState<any>()

  const [detail, setDetail] = useState<any>()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [treatmentId, setTreatmentId] = useState('')

  const [confirmLoading, setConfirmLoading] = useState(false)

  const { Option } = Select

  const data = useSelector(selectPutstorageData)

  const baseData = useSelector(selectInsuranceItem)

  const [insuranceItem, setInsuranceItem] = useState<any>()

  const insuranceArray = useSelector(selectInsuranceArray)

  const userName = useSelector(selectUserName)

  const tenantAddress = useSelector(selectTenantAddress)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const tenantName = useSelector(selectTenantName)

  const userId = useSelector(selectUserId)

  const tenantCategory = useSelector(selectTenantCategory)

  const [selectIds, setSelectIds] = useState<any>('')

  const cycleCode = sessionStorage.getItem('cycleCode')

  const [printMenueVisible, setPrintMenueVisible] = useState(false)

  const [treatmentPrintTreatmentId, setTreatmentPrintTreatmentId] = useState('')

  const [treatmentPrintPaymentId, setTreatmentPrintPaymentId] = useState('')

  const [printTemplateCategory, setPrintTemplateCategory] = useState<
    PrintTemplateCategory | undefined
  >()

  const [showCodeInputModal, setShowCodeInputModal] = useState(false)

  const [result, setResult] = useState<any>()

  const [recipeId, setRecipeId] = useState('')

  const dataParams = JSON.parse(
    sessionStorage.getItem(location.pathname) || '{}'
  )

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      setSelectIds(selectedRowKeys)
    },
    selectedRowKeys: selectIds,
  }

  useEffect(() => {
    // 获取详情
    dispatch(getPrintTemplateSettingDetail())
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
      })
  }, [])

  // 保存医保结构体
  useEffect(() => {
    if (insuranceItem && JSON.stringify(insuranceItem) !== '{}') {
      dispatch(
        setInsurance({
          ...insuranceItem,
          userName,
          userId,
          cycleCode,
          tenantCategory,
          tenantAreaCd,
          name: tenantName,
          address: tenantAddress,
          areaCode: tenantAreaCd,
          endTime: moment(insuranceItem.endTime).format(
            DateTimeFormatSimpleOnlyOne
          ),
        })
      )
    }
    return () => {
      dispatch(setInsurance({}))
    }
  }, [insuranceItem])

  useEffect(() => {
    if (insuranceArray.length !== 0) {
      setInsuranceItem(insuranceArray[0])
    }
  }, [insuranceArray])

  // 发药单上传
  const drugUpload = (
    serverType: serverType,
    treatmentId: number | string,
    responseString?: string,
    recipeItemId?: string,
    paymentId?:number
  ) => {
    dispatch(
      drugUploadAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          treatmentId,
          shipmentState: 1,
          recipeItemId: recipeItemId || undefined,
          paymentId:paymentId,
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          if(data?.isdone == "1"){
            notification.success({
              message: '上传完毕！',
            })
            dispatch(getDeliveryList(queries))
            return;
          }
          const itemId = data.recipeItemId
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '发药单上传',
            },
            (call: any, err) => {
              !err &&
              drugUpload(
                'response',
                treatmentId,
                JSON.stringify(call.netmessage),
                itemId,
                paymentId
              )
            }
          )
        } else {
          if (res.successCode === '1') {
            drugUpload('requestString', treatmentId,undefined,undefined,paymentId)
          } else {
            dispatch(getDeliveryList(queries))
          }
        }
      })
  }


  const showCodeUploadModal = (
    paymentId:string
  ) => {
    dispatch(getPaymentResults(paymentId))
      .then(unwrapResult)
      .then(async (val: any) => {
        setResult(val)
        setShowCodeInputModal(true)
      })
  }

  const removeSale3507A = (
    serverType: serverType,
    paymentId: number,
    responseString?: string
  ) => {
    dispatch(
      removeSale3507AAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          paymentId
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '冲正上传',
            },
            (call: any, err) => {
              !err &&
              removeSale3507A(
                'response',
                paymentId,
                JSON.stringify(call.netmessage)
              )
            }
          )
        } else {
          dispatch(cancelSaleUpload(String(paymentId)))
            .then(unwrapResult)
            .then(async (val: any) => {
              notification.success({
                message: "追溯码上传撤销成功",
              })
              refresh()
              showCodeUploadModal(String(paymentId))
            })
        }
      })
  }


  // 发药单批量上传
  const drugUploadA = (
    serverType: serverType,
    paymentIds: number[] | string[],
    responseString?: string,
    recipeId?: number
  ) => {
    dispatch(
      drugUploadAAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          paymentIds,
          shipmentState: 1,
          recipeId: recipeId,
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          let data = null
          try {
            data = JSON.parse(res)
          } catch (e) {
            data = strParse(res)
          }
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '发药单上传',
            },
            (call: any, err) => {
              !err &&
              drugUploadA(
                'response',
                paymentIds,
                JSON.stringify(call.netmessage),
                recipeId
              )
            }
          )
        } else {
          dispatch(getDeliveryList(queries))
        }
      })
  }

  // 退药单上传
  const returnDrugUpload = (
    serverType: serverType,
    treatmentId: number | string,
    responseString?: string,
    recipeItemId?: string,
    paymentId?:number
  ) => {
    dispatch(
      returnDrugUploadAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          treatmentId,
          shipmentState: 9,
          recipeItemId: recipeItemId || undefined,
          paymentId:paymentId
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          let data = null
          try {
            data = JSON.parse(res)
          } catch (e) {
            data = strParse(res)
          }
          if(data?.isdone == "1"){
            notification.success({
              message: '上传完毕！',
            })
            dispatch(getDeliveryList(queries))
            return;
          }
          const itemId = data.recipeItemId
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '发药单上传',
            },
            (call: any, err) => {
              !err &&
                returnDrugUpload(
                  'response',
                  treatmentId,
                  JSON.stringify(call.netmessage),
                  itemId,
                  paymentId
                )
            }
          )
        } else {
          if (res.successCode === '1') {
            returnDrugUpload('requestString', treatmentId,undefined,undefined,paymentId)
          } else {
            dispatch(getDeliveryList(queries))
          }
        }
      })
  }


  const returnDrugUploadA = (
    serverType: serverType,
    paymentIds: number[] | string[],
    responseString?: string,
    recipeId?: number
  ) => {
    dispatch(
      returnDrugUploadAAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          paymentIds,
          shipmentState: 9,
          recipeId: recipeId || undefined,
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '发药单上传',
            },
            (call: any, err) => {
              !err &&
              returnDrugUploadA(
                'response',
                paymentIds,
                JSON.stringify(call.netmessage),
                recipeId
              )
            }
          )
        } else {
          dispatch(getDeliveryList(queries))
        }
      })
  }

  useEffect(() => {
    if (!queries.current) return
    setPageLoading(true)
    dispatch(getDeliveryList({ ...queries, [DateRangeFieldName]: undefined }))
      .then(unwrapResult)
      .then((res: any) => {
        if (queries.param?.length == 9 && res.items.length == 1) {
          sessionStorage.setItem(location.pathname, JSON.stringify({...queries, param: ''}))
          dispatch(
            traceRoute({
              name: '库房发药',
              path: '/delivery/manual',
              query: `treatmentId=${res.items[0][1].treatmentId}&paymentId=${res.items[0][1]?.paymentId}&state=${deliveryState}&station=${station}&tockSalesUploadCategory=${tockSalesUploadCategoryType?tockSalesUploadCategoryType:''}&billingCategory=${queries?.billingCategory ? queries?.billingCategory : ''}`,
            })
          )
        }
      })
      .finally(() => {
        setPageLoading(false)
      })
  }, [queries])

  useEffect(() => {
    if (!queries.current) return
    sessionStorage.setItem(location.pathname, JSON.stringify(queries))
  }, [queries, deliveryState])

  useEffect(() => {
    if (
      Object.keys(dataParams).length &&
      dataParams?.shipmentsState === deliveryState
    ) {
      form.setFieldsValue({
        ...dataParams,
        billingCategory:dataParams?.billingCategory || ' '
      })
    } else {
      form.setFieldsValue({
        //[DateRangeFieldName]: DateRangeType.Today,
        ['time_dateRange']: DateRangeType.Today,
        timeHead: head,
        timeTail: tail,
        billingCategory:dataParams?.billingCategory || ' '
      })
    }
    inputRef.current!.focus({
      //获取焦点
      cursor: 'start',
    })
    form.submit()
  }, [])

  const refresh = () => {
    const values = form.getFieldsValue()
    if(!values?.timeHead && values?.time_dateRange == 6 || !values?.returnHead && values?.return_dateRange == 6){
      return 
    }
    //已退药场景下，搜索的已上传，指的是退药已上传（2）未上传指的是发药已上传但退药未上传（1）
    let ybUploadFlag = form.getFieldValue("ybUploadFlag");
    if(shipmentsState == 9){
      if(ybUploadFlag == 1){
        ybUploadFlag = 2;
      }else if(ybUploadFlag == 0){
        ybUploadFlag = 1;
      }
    }
    setQueries({
      ...dataParams,
      ...queries,
      ...values,
      ybUploadFlag:ybUploadFlag,
      current: 1
    })
  }

  const actionName = deliveryState === DeliveryState.Fulfilled ? '退药' : '发药'

  const massUpload = () => {
    if (selectIds?.length === 0) {
      notification.info({
        message: '请选择上传的数据',
      })
    }
    if (selectIds?.length > 10) {
      notification.info({
        message: '一次最多上传10条',
      })
    } else {
      selectIds?.map((id: any) => {
        if (tockSalesUploadCategoryType === 1) {
          const record = page.items as any
          const item = record.find((v: any) => {
            return v[1].paymentId === id
          }) as any
          console.log("woshiitem",item)
          if (item[1]?.ybSaleUploadStatus === 0) {
            if(insuranceItem?.insuranceCode === 'ZHEJIANG'){
              drugUploadA('requestString', [id])
            }else {
              drugUpload('requestString', item[0].treatmentId ,undefined,undefined,id)
            }


          }
        } else if (tockSalesUploadCategoryType === 9) {
          const record = page.items as any
          const item = record.find((v: any) => {
            return v[1].paymentId === id
          }) as any
          console.log("woshiitem2",item)

          if (item[1]?.ybSaleUploadStatus === 1) {
            if(insuranceItem?.insuranceCode === 'ZHEJIANG'){
              returnDrugUploadA('requestString', [id])
            }else {
              returnDrugUpload('requestString', item[0].treatmentId,undefined,undefined,id )
            }


          }else{
            notification.info({
              message: item[1]?.patientName + '未上传发药记录，无需上传退药',
            })
          }
        }
      })
    }
  }

    // 实体卡读卡
    const readEType = () => {
      readCardEHttp(
        {
          trade_args: [
            insuranceItem.countryHospitalNb,
            '01306',
            '',
            userId,
            userName,
            '',
            '',
          ],
        },
        (data, err) => {
          if (!err) {
            const idCardNumber = data?.netmessage?.split('|')?.[1];
            if(idCardNumber){
              form.setFieldsValue({
                param:idCardNumber
              })
            }
          }
        }
      )
    }
  

  const outCluedExport = () => {
    setExportLoading(true)
    dispatch(getDeliveryListExoprt({ ...dataParams, ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '库房发药.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
         return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => {
        setExportLoading(false)
      })

  }


  const checkTraceCodeCompleted = (traceCodeParam:any,  callback: (m?:any) => void) =>{
    dispatch(getCheckTraceCodeAlarm(traceCodeParam))
      .then(unwrapResult)
      .then((res: any) => {
        //0为校验不通过，需要提醒，1为校验通过。
        if(res?.flag == 0){
          Modal.confirm({
            centered: true,
            title: "追溯码提醒",
            content: (
              <div>
                <ExclamationCircleFilled
                  style={{ color: "#FFAE55", fontSize: 18 }}
                />
                &nbsp;以下药品还未采集追溯码，请确认：
                {res?.msg?.map((v:any,index:number) =>{
                  return <p key={index}>{v}</p>
                })}
              </div>
            ),
            okText: "确认无误并继续",
            cancelText: "返回",
            icon: null,
            onOk: () => {
              callback && callback();
            },
          })
        }else{
          callback && callback();
        }
      }).catch((e:any)=>{
        console.log("检查追溯码完整性异常,继续执行",e);
        callback && callback();
        // setLoading(false)
      })
  }

  const oneKeyShipOrReturn =(t:any) =>{
    setLoading(actionName == '发药' ?"ship":"return")
    setConfirmLoading(true)
    dispatch(
      directDeliver({
        paymentId: t.paymentId,
        deliveryState,
      })
    )
      .then(unwrapResult)
      .then((s) => {
        if (s.successful) {
          notification.success({
            message: '操作成功',
          })
          dispatch(getDeliveryList(queries))
          setConfirmLoading(false)
          if(actionName == '发药'){
            if (yjfyhzddy) {
              dispatch(getAllPaymentResult(t?.paymentId))
                .then(unwrapResult)
                .then((res) => {
                  setPaymentInfo(res)
                })
              setTimeout(() => {
                message.loading('正在准备打印...', 5)
              }, 100); // 3000毫秒后关闭加载消息，即3秒后关闭
              //批量循环打印
              Array.isArray(dispensingAutoPrintTemplateData) ? dispensingAutoPrintTemplateData?.map((v: any) => {
                autoPrint(t, v);
              }) : autoPrint(t, dispensingAutoPrintTemplateData);
            }
          }
        } else {
          setConfirmLoading(false)
          setErrors(s.errors)
          if (s.errors.length !== 0) {
            setIsModalVisible(true)
          } else {
            notification.error({
              message: s.message || '一键发药失败',
            })
          }
        }
      })
      .catch((v) => {
        setConfirmLoading(false)
      }).finally(()=>{
        setLoading("");
      })
  }

  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      dataIndex: 'no',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, i) => `${(page.current - 1) * page.size + i + 1}`,
    },
    {
      title: '门诊号',
      key: 'outpatientNo',
      align: 'center',
      width: Dimen.Num,
      ellipsis:true,
      render: (_, [t]) => t.outpatientNo,
    },

    {
      title: '患者姓名',
      key: 'patientName',
      width: '6rem',
      ellipsis:true,
      align: 'center',
      render: (_, [, t]) => t.patientName,
    },
    {
      title: '病历号',
      key: 'patientId',
      width: '6rem',
      ellipsis:true,
      align: 'center',
      dataIndex: 'patientId',
      render: (_, [t]) => t.patientId,
    },
    {
      title: '性别',
      key: 'gender',
      width: Dimen.Num,
      ellipsis:true,
      align: 'center',
      render: (_, [, t]) => getGenderName(t.patientSex),
    },
    {
      title: '年龄',
      key: 'patientAge',
      width: Dimen.Num,
      ellipsis:true,
      align: 'center',
      render: (_, [r]) => getAge(r?.patientAge, r?.patientMonth),
    },
    {
      title: '结算险种',
      dataIndex: 'insuranceCode',
      key:'insuranceCode',
      width: '6rem',
      ellipsis:true,
      align: 'center',
      render: (_, [, t])=>{
        return t?.insuranceCode === 'ZIFEI' || !t?.insuranceCode
          ? '自费'
          : '智慧医保'
      },
    },
    {
      title: '疾病名称',
      key: 'disease',
      align: 'center',
      width: '8rem',
      ellipsis:true,
      render: (_1, [, t]) =>
        _.chain(t.disease)
          .split(',')
          .map((d) => d.split('/')[0])
          .value(),
    },
    {
      title: '诊断科室',
      key: 'treatmentDepartmentName',
      width: '8rem',
      ellipsis:true,
      align: 'center',
      render: (_, [, t]) => t.treatmentDepartmentName,
    },
    {
      title: '诊断医生',
      key: 'treatmentDoctorName',
      width: '6rem',
      ellipsis:true,
      align: 'center',
      render: (_, [, t]) => t.treatmentDoctorName,
    },
    {
      title:
        deliveryState == DeliveryState.Returned ? '退费时间' : '结算时间',
      key: 'treatmentDoctorName',
      width: '10rem',
      ellipsis:true,
      align: 'center',
      render: (_, [, t]) =>
        t.paymentTime
          ? moment(t.paymentTime).format(DateTimeFormat)
          : '-',
    },
    // {
    //   title: '退药时间',
    //   key: 'returnShipTime',
    //   width: '10rem',
    //   ellipsis:true,
    //   align: 'center',
    //   render: (_, [, t]) =>
    //     t.returnShipTime
    //       ? moment(t.returnShipTime).format(DateTimeFormat)
    //       : '-',
    // },
    // {
    //   title:
    //     '最近一次发药时间',
    //   key: 'lastShipTime',
    //   width: '11rem',
    //   ellipsis:true,
    //   align: 'center',
    //   render: (_, [, t]) =>
    //     t.lastShipTime
    //       ? moment(t.lastShipTime).format(DateTimeFormat)
    //       : '-',
    // },
    {
      title: '追溯码上传',
      key: 'traceCode',
      width: '12rem',
      ellipsis:true,
      align: 'center',
      render: function DeliveryActions(_, [, t]) {
        const isUploaded = _[1].ybSaleUploadStatus === 1;
        return (
          <Button
            type='primary'
            className={isUploaded ? styles.traceCodeButtonUploaded : ''}
            disabled={_[1].shouldUploadTraceCodeCnt === 0}
            size='small'
            onClick={()=>{
              if (isUploaded) {
                if (t.insuranceCode == 'ZHEJIANG') {
                  removeSale3507A('requestString', t.paymentId)
                } else {
                  dispatch(cancelSaleUpload(t.paymentId))
                    .then(unwrapResult)
                    .then(async (val: any) => {
                      notification.success({
                        message: '追溯码上传撤销成功',
                      })
                      refresh()
                      showCodeUploadModal(String(t.paymentId))
                    })
                }
              } else {
                showCodeUploadModal(String(t.paymentId))
              }
            }}
          >
            {isUploaded ? '已上传 点击重传' : _[1].shouldUploadTraceCodeCnt === 0 ? '无需上传' : _[1].traceCodeCnt === 0 ? '未录入' : '未上传'}
          </Button>
        )
      }
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      width: tockSalesUploadCategoryType ? '8rem' : '16rem',
      render: function DeliveryActions(_, [, t]) {
        if (tockSalesUploadCategoryType) {

          let uploadFlag = false
          if (tockSalesUploadCategoryType === 1 && _[1].ybSaleUploadStatus === 1) {
            uploadFlag = true
          } else if (tockSalesUploadCategoryType === 9 && _[1].ybSaleUploadStatus === 2) {
            uploadFlag = true
          } else if (tockSalesUploadCategoryType === 9 && _[1].ybSaleUploadStatus === 0) {
            return '无需上传';
          }


          return uploadFlag ? (

            tockSalesUploadCategoryType === 1 ? (
              <Button type='primary' ghost size='small'
                className={styles.traceCodeButtonUploaded}
                onClick={() => {
                  if (t.insuranceCode == 'ZHEJIANG') {
                    removeSale3507A('requestString', t.paymentId)
                  } else {
                    dispatch(cancelSaleUpload(t.paymentId))
                      .then(unwrapResult)
                      .then(async (val: any) => {
                        notification.success({
                          message: '追溯码上传撤销成功',
                        })
                        refresh()
                        showCodeUploadModal(String(t.paymentId))
                      })
                  }
                }}
              >
                已上传，点击重传
              </Button>
            ) : (
              '已上传'
            )
          ) : (
            <Popconfirm
              title='确认执行此操作？'
              okText='确认'
              onConfirm={() => {
                if (tockSalesUploadCategoryType === 1) {
                  if(insuranceItem?.insuranceCode === 'ZHEJIANG'){
                    drugUploadA('requestString', [t.paymentId])
                  }else {
                    drugUpload('requestString', t.id ,undefined,undefined,t.paymentId )
                  }
                } else if (tockSalesUploadCategoryType === 9) {
                  if(insuranceItem?.insuranceCode === 'ZHEJIANG'){
                    returnDrugUploadA('requestString',[t.paymentId])
                  }else {
                    returnDrugUpload('requestString', t.id,undefined,undefined,t.paymentId )
                  }
                }
              }}
              cancelText='取消'
            >
              <Button type='primary' ghost size='small'>
                上传
              </Button>
            </Popconfirm>
          )
        } else {
          return (
            <Space>
              {deliveryState == DeliveryState.Returned &&
              t.payStatus == '5' ? (
                <></>
              ) : (
                <>
                  <Popconfirm
                    placement='top'
                    title={`是否${actionName}`}
                    okButtonProps={{ loading: confirmLoading }}
                    onConfirm={() => {
                      //1.先确定一下是否追溯码扫全了
                      if(settings?.[Checks.ZSMTXFS]?.indexOf("1")>=0 && actionName == '发药'){
                        const traceCodeParam = {
                          paymentId:t.paymentId
                        }
                        checkTraceCodeCompleted(traceCodeParam,() =>{
                          oneKeyShipOrReturn(t);
                        })
                      }else{
                        oneKeyShipOrReturn(t);
                      }
                    }}
                    okText='确认'
                    cancelText='取消'
                  >
                    <Button type='primary' size='small' loading={loading != ''}>
                      一键{actionName}
                    </Button>
                  </Popconfirm>
                  <Button
                    type='primary'
                    size='small'
                    onClick={() =>
                      dispatch(
                        traceRoute({
                          name: '库房发药',
                          path: '/delivery/manual',
                          query: `treatmentId=${t.id}&paymentId=${t?.paymentId}&state=${deliveryState}&station=${station}&tockSalesUploadCategory=${tockSalesUploadCategoryType? tockSalesUploadCategoryType :''}&billingCategory=${queries?.billingCategory ? queries?.billingCategory : ''}`,
                        })
                      )
                    }
                  >
                    手动{actionName}
                  </Button>
                </>
              )}
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      key='0'
                      onClick={() => {
                        setPrintMenueVisible(false)
                        setTreatmentId(t.id)
                      }}
                    >
                      打印处方
                    </Menu.Item>
                    <Menu.Item
                      key='1'
                      onClick={() => {
                        setPrintMenueVisible(false)
                        setPrintTemplateCategory(
                          PrintTemplateCategory.YHT
                        )
                        setTreatmentPrintTreatmentId(t.id)
                      }}
                    >
                      打印药盒贴
                    </Menu.Item>
                    <Menu.Item
                      key='2'
                      onClick={() => {
                        setPrintMenueVisible(false)
                        setPrintTemplateCategory(
                          PrintTemplateCategory.Zxd
                        )
                        setTreatmentPrintTreatmentId(t.id)
                        setTreatmentPrintPaymentId(t?.paymentId)
                      }}
                    >
                      打印输液单
                    </Menu.Item>
                     {deliveryState == DeliveryState.Unfilled  || deliveryState == DeliveryState.Fulfilled ?  <Menu.Item
                      key='3'
                      onClick={() => {
                        setPrintMenueVisible(false)
                        setPrintTemplateCategory(
                          PrintTemplateCategory.Jd
                        )
                        setTreatmentPrintTreatmentId(t.id)
                      }}
                    >
                      打印瓶贴
                    </Menu.Item> :<></>}
                  </Menu>
                }
                trigger={['click']}
              >
                <Button type='primary' size='small'>
                  打印
                  {printMenueVisible ? (
                    <CaretUpOutlined />
                  ) : (
                    <CaretDownOutlined />
                  )}
                </Button>
              </Dropdown>
            </Space>
          )
        }
      },
    },
  ]

  const autoPrint = async (val: any, oneTemplate: any) => {
    if (
      oneTemplate?.templateCode &&
      (!oneTemplate?.invoiceType ||
        oneTemplate?.invoiceType == '2')
    ) {
      //网页打印
      if (
        oneTemplate?.templateCode?.indexOf('ForWeb') > 0
      ) {
        message.loading('正在准备打印...', 3)
        getWebPrintDataMain(oneTemplate?.templateCode, val)
        message.destroy()
        //lodop打印
      } else {
        if (oneTemplate?.templateCode) {
          let status = null
          message.loading('正在准备打印...', 3)
          if (oneTemplate.invoiceType == '2') {
            dispatch(invoicenumberconfigAsync())
              .then(unwrapResult)
              .then((res: any) => {
                const data = res.records.find(
                  (v: any) => v.categoryType == 0
                )
                setChargeNumber(data)
                setInvoiceNo(data?.currentNo)
                status = {
                  insuranceCode: val?.insuranceCode,
                  invoiceCode: data.invoiceCode,
                  invoiceCoifigId: data.id,
                  invoiceNum: getZeroSupply(
                    data.currentNo,
                    data.invoiceNumberLength
                  ),
                  paymentId: val?.paymentId,
                  templateId: oneTemplate?.id,
                  treatmentId: val?.id,
                }
                print(oneTemplate, status, val, defaultPrinters[oneTemplate?.id] || undefined)
              })
              .catch((v) => {
                notification.error({
                  message: '获取发票号码失败:' + v?.message,
                })
              })
              .finally(() => {
                message.destroy()
              })

            // dispatch(invoicedetailsOpenAsync(data))
          } else {
            await print(oneTemplate, status, val, defaultPrinters[oneTemplate?.id] || undefined)
          }
        }
      }
    }
  }
  const getWebPrintDataMain = (templateCategory: string, val: any) => {
    // data 打印需要的值
    // medicalRecord 1 通用 2 中医 3 口腔 (区分什么病历)
    if (templateCategory == 'RecipeExecuteForWeb') {
      //输注执行单
      getRecipeExecuteForWeb(val)
    } else if (templateCategory == 'RecipeExecuteZLForWeb') {
      //诊疗执行单
      getRecipeExecuteZLForWeb()
    } else if (templateCategory == 'TreatmentRecordNoRecForWeb') {
      //诊断书 无处方
      getTreatmentRecordForWeb(false, val)
    } else if (templateCategory == 'TreatmentRecordForWeb') {
      //诊断书 有处方
      getTreatmentRecordForWeb(true, val)
    } else if (templateCategory == 'ChnTradRecipeForWeb') {
      // 中药处方单打印
      getPrescriptionForWeb('', 3, val)
    } else if (templateCategory == 'WesternMedicinePreferenceSettingForWeb') {
      // 西药处方单打印
      getPrescriptionForWeb('', 1, val)
    } else if (templateCategory == 'FirstClassPsychotropicPrescriptionForWeb') {
      // 精一药品处方笺打印
      getPrescriptionForWeb('精一', 1, val)
    } else if (
      templateCategory == 'SecondClassPsychotropicPrescriptionForWeb'
    ) {
      // 精二药品处方笺打印
      getPrescriptionForWeb('精二', 1, val)
    } else if (templateCategory == 'ToxicMedicationsPrescriptionForWeb') {
      // 毒性药品
      getPrescriptionForWeb('毒', 1, val)
    } else if (templateCategory == 'AnesthesiaPrescriptionForWeb') {
      // 麻醉药品处方笺
      getPrescriptionForWeb('麻醉', 1, val)
    }  else if (templateCategory == 'InvoiceFeeBillForWeb') {
      //80mm 小票结算
      getPrescriptionForWeb('小票', 1, val)
    } else {
      notification.error({
        message: '不支持的打印模板，请联系管理员',
      })
    }
  }
  const getRecipeExecuteForWeb = (val?: any) => {
    const getWebPrintContent = getWebPrintDataByPaymentId
    if (val?.paymentId) {
      dispatch(getWebPrintContent({ paymentId: val?.paymentId }))
        .then(unwrapResult)
        .then((data: any) => {
          // pagePrintFlag == 'sfPrintTag'   收费标志
          // 执行单打印西药方处方明细接口获取
          const list = data?.recipeWebPrintVOList?.map((v: any) => {
            return {
              ...v,
              itemList: v?.recipeItemWebPrintVOList,
            }
          })

          //收费页面进来的，需要打印所有处方
          // 结算时执行单打印西药处方
          const printList = list
            ?.filter((v: any) => v?.category == 1)
            ?.map((val: any) => {
              return val?.itemList
            })
            ?.flat(1)
          const sortDataList =
            _.chain(printList)
              .map((m) => fromMaterialJson(m))
              .sort((a, b) => {
                if (a.groupNumber < b.groupNumber) {
                  return -1
                }
                if (a.groupNumber > b.groupNumber) {
                  return 1
                }
                return a.sort - b.sort
              })
              .value() || []
          const printZXDList = sortDataList?.filter((v: any) => {
            return (
              v?.normalUsemethod == '静滴' ||
              v?.normalUsemethod == '肌注' ||
              v?.normalUsemethod == '静滴(JDZ)' ||
              v?.normalUsemethod == '静注' ||
              v?.normalUsemethod == '穴注' ||
              v?.normalUsemethod == '雾化吸入' ||
              v?.normalUsemethod == '静推' ||
              v?.normalUsemethod == '皮下' ||
              v?.normalUsemethod == '冲管'
            )
          })

          const dataMainContent = {
            tenantName: tenantName?.split('-')?.[0],
            userName: userName,
            dataMain: {
              treatment: data?.treatment,
              // 执行单打印数据
              materials: printZXDList,
              // 签名
              SignatureSrc: data?.printSettingData?.userSign,
              printAddress: data?.patientAddress,
            },
          }
          if (printZXDList?.length) {
            const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
            page?.document?.write(PrintZXDBody(dataMainContent)) // 写入打印页面的内容
            setTimeout(function () {
              page?.print() // 打印
              page?.close()
              setTreatmentPrintTreatmentId(val.id)
            }, 200)
          } else {
            notification.info({
              message: '暂无可打印执行单',
            })
          }
        })
    } else {
      notification.error({
        message: '缺少必要的打印参数',
      })
    }
  }
  const getRecipeExecuteZLForWeb = (val?: any) => {
    const getWebPrintContent = getWebPrintDataByPaymentId

    if (val?.paymentId) {
      dispatch(getWebPrintContent({ paymentId: val?.paymentId, printType: 1 }))
        .then(unwrapResult)
        .then((data: any) => {
          // 执行单打印西药方处方明细接口获取
          const list = data?.recipeWebPrintVOList?.map((v: any) => {
            return {
              ...v,
              itemList: v?.recipeItemWebPrintVOList,
            }
          })
          const printList = list
            ?.map((val: any) => {
              return val?.itemList
            })
            ?.flat(1)
          let printZXDList
          //收费页面进来的，需要打印所有非药品处方
          const sortDataList =
            _.chain(printList)
              .map((m) => fromMaterialJson(m))
              .sort((a, b) => {
                if (a.groupNumber < b.groupNumber) {
                  return -1
                }
                if (a.groupNumber > b.groupNumber) {
                  return 1
                }
                return a.sort - b.sort
              })
              .value() || []
          printZXDList = sortDataList?.filter((v: any) => {
            return v?.drugType == 1
          })
          //否则，只打印当前处方
          printZXDList = sortDataList?.filter((v: any) => {
            return v?.drugType == 1
          })

          const dataMainContent = {
            tenantName: tenantName?.split('-')?.[0],
            userName: userName,
            dataMain: {
              treatment: data?.treatment,
              // 执行单打印数据
              materials: printZXDList,
              // 签名
              SignatureSrc: data?.printSettingData?.userSign,
              printAddress: data?.patientAddress,
            },
          }

          if (printZXDList?.length) {
            const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
            page?.document?.write(PrintZLZXDBody(dataMainContent)) // 写入打印页面的内容
            setTimeout(function () {
              page?.print() // 打印
              page?.close()
              setTreatmentPrintTreatmentId(val.id)
            }, 200)
          } else {
            notification.info({
              message: '暂无可打印执行单',
            })
          }
        })
    } else {
      notification.error({
        message: '缺少必要的打印参数',
      })
    }
  }
  const getTreatmentRecordForWeb = (haveRecipeFlag: boolean, val?: any) => {
    const getWebPrintContent = getWebPrintDataByPaymentId

    if (val?.paymentId) {
      dispatch(getWebPrintContent({ paymentId: val?.paymentId }))
        .then(unwrapResult)
        .then((data: any) => {
          const list = data?.recipeWebPrintVOList?.map((v: any) => {
            return {
              ...v,
              itemList: v?.recipeItemWebPrintVOList,
            }
          })
          const dataMainContent = {
            tenantName: tenantName?.split('-')?.[0],
            userName: userName,
            dataMain: {
              treatment: data?.treatment,
              feeCategory: data?.feeCategory,
              insuranceArrayLength: insuranceArray.length,
              // 签名
              SignatureSrc: data?.printSettingData?.userSign,
              // 拿到当前病历下所有处方 打印诊断书时有处方就打印
              printRecipes: list,
              printAddress: data?.patientAddress,
              codeImg: document.getElementById('barcode')?.getAttribute('src'),
              JXQrCodeImg: cityCode == '330400' ? JXImg : '',
              cityCode: cityCode,
            },
          }
          if (data?.medicalRecord == 1) {
            const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
            page?.document?.write(PrintTYBody(dataMainContent, haveRecipeFlag)) // 写入打印页面的内容
            setTimeout(function () {
              page?.print() // 打印
              page?.close()
              setTreatmentPrintTreatmentId(val.id)
              document.getElementById('barcode')?.setAttribute('src', '')
            }, 200)
          } else if (data?.medicalRecord == 2) {
            const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
            page?.document?.write(PrintZYBody(dataMainContent, haveRecipeFlag)) // 写入打印页面的内容
            setTimeout(function () {
              page?.print() // 打印
              page?.close()
              setTreatmentPrintTreatmentId(val.id)
              document.getElementById('barcode')?.setAttribute('src', '')
            }, 200)
          } else if (data?.medicalRecord == 3) {
            const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
            page?.document?.write(PrintKQBody(dataMainContent, haveRecipeFlag)) // 写入打印页面的内容
            setTimeout(function () {
              page?.print() // 打印
              page?.close()
              setTreatmentPrintTreatmentId(val.id)
              document.getElementById('barcode')?.setAttribute('src', '')
            }, 200)
          }
        })
    } else {
      notification.error({
        message: '缺少必要的打印参数',
      })
    }
  }
  // 处方单打印
  const getPrescriptionForWeb = (
    typeName?: any,
    category?: any,
    val?: any,
    codeImg = ''
  ) => {
    let medicalWestPrintQuantity = 8 //固定一页8条
    // 是否打印厂家
    const cjFlag = detail?.functionList?.filter((v: any) => v?.type == 33)?.[0]
      ?.value
    if (cjFlag && (cjFlag == true || cjFlag == 'true')) {
      medicalWestPrintQuantity = typeName == '麻醉' ? 7 : 8
    } else {
      medicalWestPrintQuantity = typeName == '麻醉' ? 11 : 12
    }
    const getWebPrintContent = getWebPrintDataByPaymentId
    if (val?.paymentId) {
      dispatch(
        getWebPrintContent({
          paymentId: val?.paymentId,
          printCategory: category,
        })
      )
        .then(unwrapResult)
        .then((data: any) => {
          // let signBaseInfo = ''
          // if (
          //   data?.treatment?.doctorSignId &&
          //   data?.treatment?.doctorSignId != -1
          // ) {
          //   dispatch(
          //     getSignatureEntityAsync({
          //       signId: data?.treatment?.doctorSignId,
          //       tenantId: tenantId,
          //     })
          //   )
          //     .then(unwrapResult)
          //     .then((urlMain: any) => {
          //       signBaseInfo = urlMain?.signBaseInfo
          //     })
          // } else {
          //   signBaseInfo = ''
          // }
          // 西药
          if (category == 1) {
            const list = data?.recipeWebPrintVOList
              ?.map((v: any) => {
                return {
                  ...v,
                  itemList: v?.recipeItemWebPrintVOList,
                }
              })
              ?.map((v: any) => v?.itemList)
              ?.flat(1)

            const getWebPrintRecipeContent = getPrintRecipeAsyncByPaymentId
            if (val?.paymentId) {
              dispatch(
                getWebPrintRecipeContent({
                  paymentId: val?.paymentId,
                  printCategory: category,
                })
              )
                .then(unwrapResult)
                .then((res: any) => {
                  const allPage = Math.ceil(
                    Number(res?.recipeItemGroupNumber?.length) /
                    medicalWestPrintQuantity
                  )
                  const chunkArray = (array: any, chunkSize: any) => {
                    const result = []
                    for (let i = 0; i < array.length; i += chunkSize) {
                      result.push(array.slice(i, i + chunkSize))
                    }
                    return result
                  }
                  const chunkedArray = chunkArray(
                    res?.recipeItemGroupNumber,
                    medicalWestPrintQuantity
                  )
                  const dataMainList = {
                    chunkedArray: chunkedArray,
                    allPage: allPage,
                    tenantName: tenantName?.split('-')?.[0],
                    userName: userName,
                    cityCode: cityCode,
                    doctorMessage: data?.printSettingData,
                    zlCount: res?.serviceAmount,
                    ypCount: res?.drugAmount,
                    showFlag: {
                      zsFlag: detail?.functionList?.filter(
                        (v: any) => v?.type == 37
                      )?.[0]?.value,
                      cjFlag: detail?.functionList?.filter(
                        (v: any) => v?.type == 33
                      )?.[0]?.value,
                      blhFlag: detail?.functionList?.filter(
                        (v: any) => v?.type == 32
                      )?.[0]?.value,
                      bzFlag: detail?.functionList?.filter(
                        (v: any) => v?.type == 35
                      )?.[0]?.value,
                      jeFlag: detail?.functionList?.filter(
                        (v: any) => v?.type == 28
                      )?.[0]?.value,
                      // 是否打印诊疗
                      zlFlag: detail?.functionList?.filter(
                        (v: any) => v?.type == 39
                      )?.[0]?.value,
                      // 是否打印柜号
                      ghFlag: detail?.functionList?.filter(
                        (v: any) => v?.type == 52
                      )?.[0]?.value,
                      // 是否打印天数
                      daysFlag: detail?.functionList?.filter(
                        (v: any) => v?.type == 53
                      )?.[0]?.value,
                    },
                    // SignatureSrc: signBaseInfo,
                    typeName: typeName,
                    recipeId: data?.recipeAllid,
                    detailMessage: {
                      ...data?.treatment,
                      feeCategory: data?.feeCategory,
                      insuranceArrayLength: insuranceArray.length,
                      medicalRecord: data?.medicalRecord,
                      sex: getSexData(Number(data?.treatment?.patientSex)),
                      type:
                        data?.treatment?.insuranceCode == 'ZIFEI'
                          ? '自费'
                          : data?.treatment?.insuranceCode != 'ZIFEI' &&
                            data?.treatment?.insuranceCode != ''
                            ? '医保'
                            : '',
                      createTime: data?.treatment?.createTime
                        ? moment(data?.treatment?.createTime)?.format(
                          DateTimeFormatSimpleOnly
                        )
                        : '-',
                      codeImg: document
                        .getElementById('barcode')
                        ?.getAttribute('src'),
                    },
                    patientMessage: {
                      ...data?.patient,
                      patientAddress: data?.patientAddress,
                    },
                  }
                  const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
                  page?.document?.write(
                    typeName == '小票'
                      ? subPrintInvoiceFeeBillForWeb({
                        ...dataMainList,
                        payment: data?.payment,
                        paymentInfo: paymentInfo,
                        countyCode: countyCode,
                        wechatQrCode: tenantId,
                        itemList: val,
                        feeBill: data?.feeBill,
                        codeImg,
                      })
                      : subPrintPrescriptionContent(dataMainList)
                  ) //JsBarcode 写入打印页面的内容
                  setTimeout(function () {
                    page.print() // 打印
                    page?.close()
                    document.getElementById('barcode')?.setAttribute('src', '')
                  }, 200)
                })
            }
          } else {
            const list = data?.recipeWebPrintVOList
              ?.filter((v: any) => v?.category == 3)
              ?.map((v: any) => {
                return {
                  ...v,
                  itemList: v?.recipeItemWebPrintVOList,
                }
              })
              ?.map((v: any) => v?.itemList)
              ?.flat(1)

            const zyList = data?.recipeWebPrintVOList?.filter(
              (v: any) => v?.category == 3
            )

            const drugAmount = sum(
              zyList?.[0]?.recipeItemWebPrintVOList?.map((i: any) =>
                Number(i?.drugAmount)
              )
            )
            const tip = zyList?.[0]?.recipeItemWebPrintVOList?.[0]?.tip
            // 打印

            const medicalWestZYPrintQuantity = 24 //固定一页24条

            const allPage = Math.ceil(
              Number(list?.length) / medicalWestZYPrintQuantity
            )
            const chunkArray = (array: any, chunkSize: any) => {
              const result = []
              for (let i = 0; i < array.length; i += chunkSize) {
                result.push(array.slice(i, i + chunkSize))
              }
              return result
            }
            const chunkedArray = chunkArray(list, medicalWestZYPrintQuantity)
            const dataMainList = {
              chunkedArray: chunkedArray,
              allPage: allPage,
              tenantName: tenantName?.split('-')?.[0],
              userName: userName,
              shortName: shortName,
              doctorMessage: data?.printSettingData,
              cityCode: cityCode,
              showFlag: {
                zsFlag: detail?.functionList?.filter(
                  (v: any) => v?.type == 37
                )?.[0]?.value,
                cjFlag: detail?.functionList?.filter(
                  (v: any) => v?.type == 33
                )?.[0]?.value,
                blhFlag: detail?.functionList?.filter(
                  (v: any) => v?.type == 32
                )?.[0]?.value,
                bzFlag: detail?.functionList?.filter(
                  (v: any) => v?.type == 35
                )?.[0]?.value,
                jeFlag: detail?.functionList?.filter(
                  (v: any) => v?.type == 28
                )?.[0]?.value,
                // 是否打印诊疗
                zlFlag: detail?.functionList?.filter(
                  (v: any) => v?.type == 39
                )?.[0]?.value,
                // 是否打印柜号
                ghFlag: detail?.functionList?.filter(
                  (v: any) => v?.type == 52
                )?.[0]?.value,
                // 是否打印天数
                daysFlag: detail?.functionList?.filter(
                  (v: any) => v?.type == 53
                )?.[0]?.value,
              },
              // SignatureSrc: signBaseInfo,
              typeName: typeName,
              tcmMessage: {
                tipCount: tip,
                recipeUseMethod: zyList?.[0]?.useMethod,
                machiningTypeMsg: zyList?.[0]?.machiningName,
                mtCount: sum(
                  zyList?.[0]?.recipeItemWebPrintVOList?.map((i: any) =>
                    Number(i?.billingCategory == '03' ? i?.countPerTip : 0)
                  )
                ),
                allCount: sum(
                  zyList?.[0]?.recipeItemWebPrintVOList?.map((i: any) =>
                    Number(i?.billingCategory == '03' ? i?.drugCount : 0)
                  )
                ),
                costPerPatch: Number(drugAmount / Number(tip))?.toFixed(2),
                fryingFee: Number(
                  zyList?.[0]?.recipeItemWebPrintVOList?.find(
                    (v: any) => v.billingCategory === '97'
                  )?.drugAmount
                )?.toFixed(2),
                amount: Number(
                  sum(
                    zyList?.[0]?.recipeItemWebPrintVOList?.map((i: any) =>
                      Number(i?.drugAmount)
                    )
                  )
                )?.toFixed(2),
              },
              recipeId: data?.recipeAllid,
              detailMessage: {
                ...data?.treatment,
                feeCategory: data?.feeCategory,
                insuranceArrayLength: insuranceArray.length,
                sex: getSexData(Number(data?.treatment?.patientSex)),
                type:
                  data?.treatment?.insuranceCode == 'ZIFEI'
                    ? '自费'
                    : data?.treatment?.insuranceCode != 'ZIFEI' &&
                      data?.treatment?.insuranceCode != ''
                      ? '医保'
                      : '',
                createTime: data?.treatment?.createTime
                  ? moment(data?.treatment?.createTime)?.format(
                    DateTimeFormatSimpleOnly
                  )
                  : '-',
                codeImg: document
                  .getElementById('barcode')
                  ?.getAttribute('src'),
              },
              payment: {
                ...data?.payment,
                createTime: data?.payment?.createTime
                  ? moment(data?.treatment?.createTime)?.format(
                    DateTimeFormatSimpleOnlyOne
                  )
                  : '',
              },
              patientMessage: {
                ...data?.patient,
                patientAddress: data?.patientAddress,
              },
              dataList: list,
            }
            const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印

            page?.document?.write(subZYPrintPrescriptionContent(dataMainList)) // 写入打印页面的内容
            setTimeout(function () {
              page.print() // 打印
              page?.close()
              document.getElementById('barcode')?.setAttribute('src', '')
            }, 200)
          }
        })
    }
  }

  const print = async (t: PrintTemplate, status?: any, val?: any, printer?: string) => {
    const offset = offsets[t.id]
    const left = offset?.left || 0
    const top = offset?.top || 0
    message.destroy()
    return dispatch(
      printTemplate({
        templateCode: t.templateCode,
        topOffset: top,
        leftOffset: left,
        treatmentId: val?.id,
        paymentId: val?.paymentId,
        preview: false,
        status,
        printer: printer
      })
    )
  }
  const getZeroSupply = (
    invoiceNumber: string,
    invoiceNumberLength: number
  ) => {
    if (
      !invoiceNumberLength ||
      invoiceNumberLength <= 0 ||
      invoiceNumberLength <= invoiceNumber.length ||
      invoiceNumberLength > 15
    ) {
      return invoiceNumber
    } else {
      const diffLength = invoiceNumberLength - invoiceNumber.length
      let Azero = ''
      for (let i = 0; i < diffLength; i++) {
        Azero += '0'
      }
      return Azero + '' + invoiceNumber
    }
  }
  return (
    <Col
      style={{
        marginTop: 10,
        height: 'calc(100% - 10px)',
        overflowY: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.pn,
        borderRadius: '10px',
        padding: '0px 15px',
      }}
    >
      <Form
        form={form}
        autoComplete='off'
        onFinish={(values) => {
          if(!values?.timeHead && values?.time_dateRange == 6 || !values?.returnHead && values?.return_dateRange == 6){
            return 
          }
          const data =
            dataParams?.shipmentsState === deliveryState ? dataParams : {}
          //已退药场景下，搜索的已上传，指的是退药已上传（2）未上传指的是发药已上传但退药未上传（1）
          let ybUploadFlag = form.getFieldValue("ybUploadFlag");
          if(shipmentsState == 9){
            if(ybUploadFlag == 1){
             ybUploadFlag = 2;
            }else if(ybUploadFlag == 0){
              ybUploadFlag = 2;
            }
          }
          setQueries({
            ...data,
            ...queries,
            ...values,
            ybUploadFlag:ybUploadFlag,
            current: data?.current || 1,
          })
        }}
      >
        <Row
          align='middle'
          style={{ height: '3.75rem', alignItems: 'center' }}
          justify='space-between'
        >
          <Space>
            <Form.Item name='param' noStyle>
              <Input
                ref={inputRef}
                maxLength={20}
                placeholder='患者姓名/手机号/病历号'
                style={{ width: '15rem' }}
                onChange={refresh}
              />
            </Form.Item>
            <DateSelect
              onlyTime='time'
              options={DateRangeNoYearButLastMonth}
              placeholder={
                deliveryState == DeliveryState.Returned
                  ? '发药时间'
                  : '结算时间'
              }
              labelPrefix={
                ''
                // deliveryState == DeliveryState.Returned
                //   ? '退费时间-'
                //   : '结算时间-'
              }
              namePrefix='time'
              style={{ width: '8.5rem' }}
              // initialValue={DateRangeType.Today}
              allowClear={false}
              onChange={refresh}
            />
            {/* {shipmentsState == 9 && (
              <DateSelect
                onlyTime='return'
                options={DateRangeNoYearButLastMonth}
                placeholder='退药时间'
                labelPrefix=''
                namePrefix='return'
                style={{ width: '8.5rem' }}
                // initialValue={DateRangeType.Today}
                allowClear={false}
                onChange={refresh}
              />
            )} */}
            {tockSalesUploadCategoryType && (
              <>
              <Form.Item name='ybUploadFlag' noStyle>
                <Select
                  placeholder='是否已上传'
                  allowClear
                  style={{ width: '8.5rem' }}
                  // suffixIcon={<CaretDownFilled />}
                  onChange={refresh}
                >
                  {uploadOptions.map((v) => (
                    <Option value={v.value} key={v.value}>
                      {v.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='insuranceCode' noStyle>
              <Select
                placeholder='结算险种'
                style={{ width: '8.25rem' }}
                allowClear
                onChange={form.submit}
              >
                <Select.Option value={''}>全部</Select.Option>
                <Select.Option value={'ZIFEI'}>自费</Select.Option>
                {insuranceArray.map((v) => (
                  <Select.Option value={v?.insuranceCode} key={v.id}>
                    {v.insuranceName}
                  </Select.Option>
                ))}
              </Select>
              </Form.Item>
            </>
            )}
            <Button type='primary' onClick={refresh} loading={pageLoading}>
              查询
            </Button>
            {insuranceItem && insuranceItem?.insuranceCode === 'JIANGSU'  && (<Button
            type='primary'
            onClick={() => {
              readEType()
            }}
          >
            读电子凭证
          </Button>)}
          </Space>
          <Space>
            <Form.Item name='billingCategory' noStyle initialValue={' '}>
              <Radio.Group  onChange={refresh}>
                <Radio value=' '>全部</Radio>
                <Radio value='01'>西药</Radio>
                <Radio value='03'>中药</Radio>
              </Radio.Group>
            </Form.Item>
            {!tockSalesUploadCategoryType && (
              <Button type='primary' onClick={() => outCluedExport()} loading={exportLoading}>
                导出
              </Button>
            )}
            {tockSalesUploadCategoryType && (
              <Button type='primary' onClick={() => massUpload()}>
                批量上传
              </Button>
            )}
          </Space>
        </Row>
      </Form>
      <EditableList<DeliveryItem>
        page={page}
        loading={pageLoading}
        onRow={([, t]) => ({
          onDoubleClick: () => {
            dispatch(
              traceRoute({
                name: '库房发药',
                path: '/delivery/manual',
                query: `treatmentId=${t.id}&paymentId=${t?.paymentId}&state=${deliveryState}&station=${station}&tockSalesUploadCategory=${tockSalesUploadCategoryType ? tockSalesUploadCategoryType:''}&billingCategory=${queries?.billingCategory ? queries?.billingCategory : ''}`,
              })
            )
          },
        })}
        rowSelection={
          {
            ...rowSelection,
          } as TableRowSelection<any>
        }
        columns={
          tockSalesUploadCategoryType ? 
          columns.filter((m) => m.key !== 'traceCode' && m.key !== 'returnShipTime'):
           shipmentsState != 1 ? shipmentsState == 9 ? columns.filter((m) => m.key !== 'traceCode' && m.key != 'insuranceCode')  : columns.filter((m) => m.key !== 'returnShipTime' &&  m.key !== 'traceCode' && m.key != 'insuranceCode'):
           shipmentsState == 1 ? columns.filter((m) => m.key != 'insuranceCode' && m.key !== 'returnShipTime') :
           columns
        }
        onChangePage={
          (current, size) => {
            setQueries({ ...queries, current, size })
          }
        }
        rowKey={(m: any) => m[1]?.paymentId}
      />
      <Modal
        title={`${actionName}失败`}
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false)
        }}
        cancelButtonProps={{
          style: {
            display: 'none',
          },
        }}
        okText='确认'
        onOk={() => {
          setErrors([])
          setIsModalVisible(false)
        }}
      >
        <Table
          dataSource={errors}
          columns={[
            {
              title: '药品名称',
              dataIndex: 'name',
              align: 'center',
            },
            {
              title: '药品数量',
              dataIndex: 'count',
              align: 'center',
            },
            {
              title: '原因',
              dataIndex: 'message',
              align: 'center',
            },
          ]}
          pagination={false}
          rowKey={(_, i) => `${i}`}
        />
      </Modal>
      <RecipeListModal
        fyState={true}
        shipmentsState={shipmentsState}
        treatmentId={treatmentId}
        visible={!!treatmentId}
        onCancel={() => setTreatmentId('')}
      />
      <PrintTemplateModal
        pagePrintFlag={'sfPrintTag'}
        paymentId={treatmentPrintPaymentId}
        templateCategory={printTemplateCategory}
        treatmentId={treatmentPrintTreatmentId}
        visible={!!treatmentPrintTreatmentId}
        onCancel={() => {
          setTreatmentPrintTreatmentId('')
          setTreatmentPrintPaymentId('')
        }}
      />
      <TraceCodeInputModal
        showCodeInputModal={showCodeInputModal}
        paymentResult={result}
        onCancel={() => setShowCodeInputModal(false)}
        onOk={() => {
          setShowCodeInputModal(false)
          refresh()
        }}
        isShowUpload={true}
      />
    </Col>
  )
}
